import { render, staticRenderFns } from "./ListAssignments.vue?vue&type=template&id=1238726c&scoped=true&"
import script from "./ListAssignments.vue?vue&type=script&lang=js&"
export * from "./ListAssignments.vue?vue&type=script&lang=js&"
import style0 from "./ListAssignments.vue?vue&type=style&index=0&id=1238726c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1238726c",
  null
  
)

export default component.exports